import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AbstractHttpService } from './http-abstract.service';
import {
	TicketReportDto,
	TicketReportPreviewDto,
	TicketReportPreviewRowDto,
	WorkflowDto,
} from './dto';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class HttpTicketReportService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/ticket_report', authService);
	}
	public getAll(): Observable<TicketReportDto[]> {
		return super.doGet(true, '/');
	}
	public get(id: number): Observable<TicketReportDto> {
		return super.doGet(true, `/${id}`);
	}
	public create(
		workflowId: number,
		payload: TicketReportDto,
	): Observable<TicketReportDto> {
		return super.doPost(true, `/workflow:${workflowId}/`, payload);
	}
	public save(
		ticketReportId: number,
		payload: TicketReportDto,
	): Observable<TicketReportDto> {
		return super.doPost(true, `/${ticketReportId}`, payload);
	}
	public preview(
		workflowId: number,
		filter: Date,
		payload: TicketReportDto,
	): Observable<TicketReportPreviewDto> {
		const pad = (n: number) => n.toString().padStart(2, '0');
		const dateStr = `${filter.getFullYear()}-${pad(filter.getMonth() + 1)}-${pad(filter.getDate())}`;
		return super.doPost(
			true,
			`/${workflowId}/preview?dateFilter=${encodeURIComponent(dateStr)}`,
			payload,
		);
	}
	public download(
		workflowId: number,
		filter: Date,
		payload: TicketReportDto,
	): Observable<any> {
		const pad = (n: number) => n.toString().padStart(2, '0');
		const dateStr = `${filter.getFullYear()}-${pad(filter.getMonth() + 1)}-${pad(filter.getDate())}`;
		return super.doPostAndDownloadFile(
			true,
			`/${workflowId}/download?dateFilter=${encodeURIComponent(dateStr)}`,
			payload,
		);
	}
	public run(
		startDate: Date,
		endDate: Date,
		includeSummary: boolean,
		reports: TicketReportDto[],
	): Observable<any> {
		const pad = (n: number) => n.toString().padStart(2, '0');
		const toDateStr = (d: Date) =>
			`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
		const startDateStr = toDateStr(startDate);
		const endDateStr = toDateStr(endDate);

		let reportIds = '';
		let seperator = '';
		for (let item of reports) {
			reportIds += seperator + item.id;
			seperator = ',';
		}

		return super.doDownloadFile(
			true,
			`/run?includeSummary=${includeSummary}&startDate=${encodeURIComponent(startDateStr)}&endDate=${encodeURIComponent(endDateStr)}&reportIds=${encodeURIComponent(reportIds)}`,
		);
	}
}
